export const TipoPersonaArray =[
    {id:'F',display:'Fisica'},
    {id:'M',display:'Moral'},
]

const TipoPersonaArrayMayusculas = TipoPersonaArray.map(item => {
    return {
        id: item.id,
        display: item.display.toUpperCase()
    };
});

export { TipoPersonaArrayMayusculas };